import clsx from "clsx";

import { PageItemStatusIcon } from "components/materials/page/PageItemStatusIcon";
import { STATUS_COLORS } from "components/materials/page/helpers";
import { PageType } from "components/server-types";
import { useAppSelector } from "store/index";
import { selectCurrentSectionId } from "store/selectors";
import { Link } from "utils/routing";
import { pageUrl } from "utils/urls";

/**
 * For a topic pages, shows "Topic {index}: {title}".
 * For other pages, shows "{title}".
 * Links directly to the page.
 *
 * kind="link" shows blue, smaller text (used on assessment dashboards)
 * kind+"text" shows black, larger text (used in sidebar and "assigned pages" lists)
 */
export const PageLink = ({
  className,
  page,
  withIcon,
  kind = "link",
}: {
  className?: string;
  page: PageType;
  kind?: "link" | "text";
  withIcon?: boolean;
}) => {
  const sectionId = useAppSelector(selectCurrentSectionId);

  const kindStyles = kind === "text" ? "unlink text-black-tint-20 body-s" : "body-xs";

  const href = sectionId ? pageUrl(sectionId, page.id) : "";

  return (
    <div className="flex min-w-12 items-center justify-start gap-2">
      {withIcon && (
        <PageItemStatusIcon
          color={page.released_at ? STATUS_COLORS.released : STATUS_COLORS.unreleased}
        />
      )}
      <Link className={clsx("page-title block", kindStyles, className)} to={href}>
        {page.title}
      </Link>
    </div>
  );
};
